import React from 'react';

import { Box, Button, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ShowErrors } from 'common/components';
import { ReactHookFormInput } from 'common/components/form/RHF';
import yupResolver from 'common/utils/yupResolver';

import validate from '../validateSecondStep';

const SecondStepAuthForm = ({
    errorsSession,
    formValues,
    handleResendCode,
    handleSubmitInitSession,
    initialValues,
    isLoadingSession,
    isResendingCode,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    return (
        <form onSubmit={handleSubmit(handleSubmitInitSession)}>
            <Stack spacing={2}>
                <ReactHookFormInput
                    control={control}
                    fontSize="1.5rem"
                    fontWeight="bold"
                    name="code"
                    placeholder={t('Code')}
                    textAlign="center"
                    type="text"
                    variant="outlined"
                />

                <ShowErrors
                    errors={errorsSession}
                    severity="error"
                    variant="filled"
                />
            </Stack>

            <Box sx={{ textAlign: 'center', marginTop: 3 }}>
                <Button
                    disabled={isLoadingSession || isResendingCode}
                    fullWidth
                    type="submit"
                >
                    {isLoadingSession ? `${t('Loading')}...` : t('Log in')}
                </Button>

                <Box sx={{ marginTop: 2 }}>
                    <Button
                        color="inherit"
                        disabled={isLoadingSession || isResendingCode}
                        fullWidth
                        onClick={() => handleResendCode(formValues)}
                        variant="text"
                    >
                        {isResendingCode
                            ? `${t('Resending code')}...`
                            : t('Resend code')}
                    </Button>
                </Box>
            </Box>
        </form>
    );
};

SecondStepAuthForm.propTypes = {
    errorsSession: PropTypes.array,
    formValues: PropTypes.object,
    handleResendCode: PropTypes.func,
    handleSubmitInitSession: PropTypes.func,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    isResendingCode: PropTypes.bool,
};

export default SecondStepAuthForm;
